export const AsrSupportLanguage = [
  'zh-cn', // 中文
  'en', // 英文
  'ja', // 日文
  'es', // 西班牙
  'ar', // 阿拉伯
  'ko', // 韩语
  'th', // 泰语
  'in', // 印尼语
  'ru', // 俄语
  'vi', // 越南语
  'fr', // 法语
  'de', // 德语
  'it', // 意大利语
  'hi', // 印地语
  'ms', // 马来语
  'pt', // 葡萄牙语
]

/** 使用前参考 @样式设置 @ve-pro/src/components/icon-language.vue   */
export const flagsIconMapper = {
  v3: '🌍', // 不限语言 (支持77种语言)
  v1: '🌍', // 不限语言 (支持26种语言)
  'zh-cn': '🇨🇳', // cn
  'zh-hk': '🇨🇳', // cn 备选：🇭
  'zh-tw': '🇨🇳', // cn 备选：🇹🇼
  zh: '🇨🇳', // cn 备选：🇹🇼
  en: '🇺🇸', // us
  ja: '🇯🇵', // jp
  ko: '🇰🇷', // kr
  br: '🇧🇷', // br
  // see: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
  // see: https://en.wikipedia.org/wiki/IETF_language_tag
  af: '🇿🇦', // 南非荷兰语，使用南非 // Afrikaans(af) - 南非荷兰语
  fil: '🇵🇭', // 菲律宾语
  ak: '🇬🇭', // 加纳 阿坎 // Akan(ak) - 阿坎
  am: '🇪🇹', // 埃塞俄比亚 // Amharic(am) - 阿姆哈拉语
  ar: '🌍', // 阿拉伯语 🇦🇪🇸🇦 // Arabic(ar) - 阿拉伯语
  be: '🇧🇾', // 白俄罗斯 // Belarusian(be) - 白俄罗斯语
  bn: '🇧🇩', // 孟加拉 // Bengali(bn) - 孟加拉语
  bh: '🇮🇳', // 博杰普尔语 5%的印度 // Bhojpuri(bh) - 博杰普尔语
  nb: '🇳🇴', // Bokmal 挪威 // Bokmal(nb) - 书面挪威语
  ceb: '🇵🇭', // 宿务语 菲律宾南部, // Cebuano(ceb) - 宿务语
  ny: '🇲🇼', // 马拉维 切瓦语 // Chewa(ny) - 奇瓦语
  cs: '🇨🇿', // 捷克 // Czech(cs) - 捷克语
  da: '🇩🇰', // 丹麦 // Danish(da) - 丹麦语
  eo: '🌍', // 世界语 // Esperanto(eo) - 世界语
  ka: '🇬🇪', // 格鲁吉亚 // Georgian(ka) - 格鲁吉亚语
  el: '🇬🇷', // 希腊 // Greek(el) - 希腊语
  gu: '🌍', // 印度和上面那一块 🇮🇳 // Gujarati(gu) - 古吉拉特语
  ha: '🌍', // 非洲中部 🇹🇩🇹🇬🇧🇯🇨🇲🇬🇭🇳🇪🇳🇬🇸🇩 // Hausa(ha) - 豪萨语
  he: '🇮🇱', // 以色列 // Hebrew(he) - 希伯来语
  hi: '🇮🇳', // 印度 // Hindi(hi) - 印地语
  ig: '🇳🇬', // 伊博语 尼日利亚 // Igbo(ig) - 伊博语
  jw: '🇮🇩', // 印度尼西亚 // Javanese(jw) - 爪哇语
  kn: '🇮🇳', // 印度西南部 // Kannada(kn) - 卡纳达语
  km: '🇰🇭', // 柬埔寨 // Khmer(km) - 高棉语
  ku: '🇮🇷', // 库尔德语 伊朗 // Kurdish(ku) - 库尔德语
  ms: '🇲🇾', // 马来语 🌍 // Malay(ms) - 马来语
  ml: '🇮🇳', // 马拉雅拉姆语 印度古典语言 // Malayalam(ml) - 马拉雅拉姆语
  mr: '🇮🇳', // 马拉地语 印度 // Marathi(mr) - 马拉地语
  ne: '🇳🇵', // 尼泊尔 // Nepali(ne) - 尼泊尔语
  or: '🇮🇳', // 奥迪亚语 印度东部 // Oriya(or) - 奥里亚语
  om: '🇰🇪', // 奥罗莫语 非洲东部凸起来那块🌍 肯尼亚为代表 // Oromo(om) - 奥罗莫语
  fa: '🇮🇷', // 伊朗 // Persian(fa) - 波斯语
  pa: '🇮🇳', // 旁遮普语 印度 // Punjabi(pa) - 旁遮普语
  rn: '🇧🇮', // Kirundi Rundi 布隆迪的国语 其他在用国🇷🇼🇹🇿🇨🇩🇨🇬🇺🇬🇰🇪  // Rundi(rn) - 克伦迪语
  sr: '🇷🇸', // 塞尔维亚 // Serbian(sr) - 塞尔维亚语
  sn: '🇿🇼', // 津巴布韦修纳族的班图语 // Shona(sn) - 绍纳语
  sl: '🇸🇮', // 斯洛文尼亚 // Slovene(sl) - 斯洛文尼亚语
  sv: '🇸🇪', // 瑞典 // Swedish(sv) - 瑞典语
  ta: '🇮🇳', // 泰米尔语 印度 // Tamil(ta) - 泰米尔语
  te: '🇮🇳', // 印度 // Telugu(te) - 泰卢固语
  ti: '🇪🇷', // 厄立特里亚 // Tigrinya(ti) - 提格利尼亚语
  tk: '🇹🇲', // 土库曼斯坦 // Turkmen(tk) - 土库曼语
  uk: '🇺🇦', // 乌克兰 // Ukrainian(uk) - 乌克兰语
  ur: '🇵🇰', // 巴基斯坦 // Urdu(ur) - 乌尔都语
  ug: '🌍', // 维吾尔语 🇨🇳🇰🇿🇰🇬🇺🇿 // Uyghur(ug) - 维吾尔语
  vi: '🇻🇳', // 越南 // Vietnamese(vi) - 越南语
  yi: '🌍', // 犹太语 哪哪都有一点 // Yiddish(yi) - 意第绪语
  yo: '🇳🇬', // 西非 尼日利亚 // Yoruba(yo) - 约鲁巴语
  zu: '🇿🇦', // 南非 // Zulu(zu) - 祖鲁语
  // 以下为设计稿提供标准
  az: '🇦🇿',
  bd: '🇧🇩',
  bg: '🇧🇬',
  bi: '🇧🇮',
  by: '🇧🇾',
  cn: '🇨🇳',
  cz: '🇨🇿',
  de: '🇩🇪',
  dk: '🇩🇰',
  ee: '🇪🇪',
  er: '🇪🇷',
  es: '🇪🇸',
  et: '🇪🇹',
  fi: '🇫🇮',
  fr: '🇫🇷',
  ge: '🇬🇪',
  gh: '🇬🇭',
  gr: '🇬🇷',
  hr: '🇭🇷',
  ht: '🇭🇹',
  hu: '🇭🇺',
  id: '🇮🇩',
  il: '🇮🇱',
  in: '🇮🇳',
  iq: '🇮🇶',
  ir: '🇮🇷',
  it: '🇮🇹',
  jp: '🇯🇵',
  kh: '🇰🇭',
  kr: '🇰🇷',
  lk: '🇱🇰',
  lt: '🇱🇹',
  lv: '🇱🇻',
  mg: '🇲🇬',
  mk: '🇲🇰',
  mm: '🇲🇲',
  mw: '🇲🇼',
  my: '🇲🇾',
  ng: '🇳🇬',
  nl: '🇳🇱',
  no: '🇳🇴',
  np: '🇳🇵',
  tl: '🇹🇱',
  ph: '🇵🇭',
  pk: '🇵🇰',
  pl: '🇵🇱',
  pt: '🇵🇹',
  ro: '🇷🇴',
  rs: '🇷🇸',
  ru: '🇷🇺',
  rw: '🇷🇼',
  se: '🇸🇪',
  si: '🇸🇮',
  so: '🇸🇴',
  th: '🇹🇭',
  tm: '🇹🇲',
  tr: '🇹🇷',
  ua: '🇺🇦',
  us: '🇺🇸',
  uz: '🇺🇿',
  vn: '🇻🇳',
  za: '🇿🇦',
  zw: '🇿🇼',
}

// 需要特殊处理的icon
const specialIconMapper = {
  v3: '🌍', // 不限语言 (支持77种语言)
  tw: '🇨🇳', // cn 备选：🇹🇼
}

// 根据国家码生成对应的国旗
export function getFlagEmoji(countryCode) {
  if (specialIconMapper[countryCode.toLowerCase()]) {
    return specialIconMapper[countryCode.toLowerCase()]
  }
  // 字母到区域指标符号的映射
  const letterToRegionalIndicator = {}
  for (let i = 65; i <= 90; i++) {
    letterToRegionalIndicator[String.fromCharCode(i)] = String.fromCodePoint(
      0x1f1e6 + i - 65,
    )
  }

  // 将国家代码转换为 emoji
  let flagEmoji = ''
  for (const letter of countryCode.toUpperCase()) {
    flagEmoji += letterToRegionalIndicator[letter]
  }
  return flagEmoji
}
